import Vue from 'vue'
import jsCookie from 'js-cookie'
import { InfiniteScroll, Lazyload } from 'mint-ui'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import App from './App'
import router from './router'
import store from './store'
import './assets/css/app.scss'
import filters from './plugins/filters'
import directives from './plugins/directives'
import middlewares from './plugins/middlewares'
import mixins from './plugins/mixins'

import { VUE_APP_SEVERENV } from './env'

Vue.config.productionTip = false

Vue.use(filters)
Vue.use(directives)
Vue.use(InfiniteScroll)
Vue.use(middlewares)
mixins(Vue)
Vue.use(Lazyload)

/* eslint-disable no-new */
const Main = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const isDEV = process.env.NODE_ENV === 'development'
const BETA = VUE_APP_SEVERENV === 'BETA'

Vue.config.devtools = isDEV || BETA
if (!isDEV) {
  const VueIntegration = Integrations.Vue
  Sentry.init({
    dsn: 'https://cbdec40a9b914f90a448eefe62a2f727@trap.cekid.com/72',
    environment: BETA ? 'BETA' : 'production',
    integrations: [
      new VueIntegration({ Vue, attachProps: true, logErrors: true })
    ],
    release: '' // --sentry release--
  })
  Sentry.setUser({
    uid: jsCookie.get('uid')
  })
}

export default Main
